import { render, staticRenderFns } from "./LoginMfaSetup.vue?vue&type=template&id=850a7f6a&scoped=true&"
import script from "./LoginMfaSetup.vue?vue&type=script&lang=ts&"
export * from "./LoginMfaSetup.vue?vue&type=script&lang=ts&"
import style0 from "./LoginMfaSetup.vue?vue&type=style&index=0&id=850a7f6a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850a7f6a",
  null
  
)

export default component.exports